import api, { mailerServiceApi } from './api';
import { GET, gmailRoutes, POST } from '../constants/api';

export const authorizeGmailAccount = domain =>
  mailerServiceApi({
    method: GET,
    url: gmailRoutes.AUTHORIZE,
    withoutAuthorization: false,
    params: { domain },
  });

export const authorizeGmailAccountSuccess = data =>
  mailerServiceApi({
    method: POST,
    url: gmailRoutes.AUTHORIZE_SUCCESS,
    withoutAuthorization: false,
    data,
  });

export const getAuthorizedGmailAccounts = () =>
  api({
    method: GET,
    url: gmailRoutes.GET_AUTHORIZED_ACCOUNTS,
    withoutAuthorization: false,
  });

export const getGmailCampaignHistory = dateRange =>
  api({
    method: GET,
    url: gmailRoutes.GET_CAMPAIGN_HISTORY,
    withoutAuthorization: false,
    params: dateRange,
  });

export const getActiveGmailCampaignsSummary = () =>
  api({
    method: GET,
    url: gmailRoutes.GET_ACTIVE_CAMPAIGNS_SUMMARY,
    withoutAuthorization: false,
  });

export const getGmailAccountMetrics = id =>
  api({
    method: GET,
    url: gmailRoutes.GET_GMAIL_ACCOUNT_METRICS(id),
    withoutAuthorization: false,
  });

export const getGmailAccountWatchStatus = async () =>
  api({
    method: GET,
    url: gmailRoutes.GET_GMAIL_ACCOUNT_WATCH_STATUS,
  });

export const watchGmailAccounts = async () =>
  api({
    method: POST,
    url: gmailRoutes.WATCH_GMAIL_ACCOUNTS,
  });

export const unwatchGmailAccounts = async () =>
  api({
    method: POST,
    url: gmailRoutes.UNWATCH_GMAIL_ACCOUNTS,
  });

export const getGmailAccountQuota = () => {
  return api({
    method: GET,
    url: gmailRoutes.GET_GMAIL_DAILY_LIMIT,
  }).then(data => data.data);
};
